import { ClientId, formatCurrency } from "@sp-crm/core";
import React from "react";
import { Link, useHistory } from "react-router-dom";
import { useNewLayout } from "store/selectors/hooks";
import { useGetClientQuery } from "../../../../generated/graphql";
import { Col } from "../../../shared/grid";

interface Props {
    clientId: ClientId;
}

export const InvoiceSummary: React.FC<Props> = props => {
    const queryKey = { id: props.clientId };
    const router = useHistory();
    const useNewLayoutValue = useNewLayout();

    const navigate = React.useCallback(() => {
        router.push(`/clients/show/${props.clientId}/invoices`);
    }, [router, props.clientId]);
    const query = useGetClientQuery(queryKey);
    if (
        query.data?.getClient?.invoices?.length !== 0 ||
        query.data?.getClient?.totalInvoiceAmountCents !== 0
    ) {
        const invoiceCount = (query.data?.getClient?.invoices || []).filter(
            i => i.status !== "void",
        ).length;

        const invoiceDisplay = (
            <>
                {formatCurrency(
                    (query.data?.getClient?.totalInvoiceAmountCents ?? 0) / 100,
                )}
                {invoiceCount > 1 ? (
                    <>
                        &nbsp;
                        <span>({invoiceCount} invoices)</span>
                    </>
                ) : null}
            </>
        );

        if (useNewLayoutValue) {
            return (
                <>
                    <div onClick={navigate}>
                        <button
                            type="button"
                            className="rounded-full bg-blue-50 px-3 py-1 flex items-center gap-2 shadow border border-zinc-200 text-sm font-medium text-zinc-800 hover:bg-blue-100 transition"
                            aria-label="Invoice">
                            <div className="text-xs text-zinc-500">Invoice</div>
                            <div className="font-semibold">{invoiceDisplay}</div>
                        </button>
                    </div>
                </>
            );
        }

        return (
            <Col className="widget">
                <div className="action-bar-component" onClick={navigate}>
                    <div className="action-bar-label">Invoice</div>
                    <div className="action-bar-value">
                        <Link to={`/clients/show/${props.clientId}/invoices`}>
                            {invoiceDisplay}
                        </Link>
                    </div>
                </div>
            </Col>
        );
    }
    return null;
};
